import { SubjectManager } from "../utils/subject-manager";

export const dataAnnotationsEventsService = new SubjectManager();
